<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (loading) {
<div class="formLoader"><i class="fa fa-spinner fa-spin gt-refresh"></i></div>
}

  @if (!loading) {
<div>
    <div class="row-space">
      <label>System Generated Basket Name:</label>
      <input class="form-control" [ngModel]="basketName" readonly>
    </div>
    <div class="row-space">
      <label>Select Source:</label>
      <select class="form-control" [ngModel]="selectedSource" (ngModelChange)="selectedSource=$event; updateBasket()">
        <option [ngValue]="null">Select</option>
        @for (item of sourceOptions; track $index) {
<option [ngValue]="item">{{ item.SOURCE }}</option>
}
      </select>
      <div class="hint">Foreign Percent: {{ selectedSource?.SOURCE_PERCENT || '' }}%</div>
    </div>
    <div class="row-space">
      <label>Select FTC:</label>
      <select class="form-control" [ngModel]="selectedFtc" (ngModelChange)="selectedFtc=$event; updateBasket()">
        <option [ngValue]="null">Select</option>
        @for (item of ftcOptions; track $index) {
<option [ngValue]="item">{{ item.FTC }}</option>
}
      </select>
    </div>
    <div class="row-space">
      <label>Select PASSIVE:</label>
      <select class="form-control" [disabled]="isPassiveDisabled()" [ngModel]="selectedPassive" (ngModelChange)="selectedPassive=$event; updateBasket()">
        <option [ngValue]="null">Select</option>
        @for (item of passiveOptions; track $index) {
<option [ngValue]="item">{{ item.PASSIVE }}</option>
}
      </select>
    </div>
    <div class="row-space">
      <label>Select SUBPART F:</label>
      <select class="form-control" [ngModel]="selectedSubf" (ngModelChange)="selectedSubf=$event; updateBasket()">
        <option [ngValue]="null">Select</option>
        @for (item of subfOptions; track $index) {
<option [ngValue]="item">{{ item.SUBF }}</option>
}
      </select>
    </div>
    <div class="row-space">
      <label>Select FPHCI:</label>
      <select class="form-control" [disabled]="isFphciDisabled()" [ngModel]="selectedFphci" (ngModelChange)="selectedFphci=$event; updateBasket()">
        <option [ngValue]="null">Select</option>
        @for (item of fphciOptions; track $index) {
<option [ngValue]="item">{{ item.FPHCI }}</option>
}
      </select>
    </div>
    <div class="row-space">
      <label>Select 902 Company Name:</label>
      <select class="form-control" [ngModel]="selected902Name" (ngModelChange)="selected902Name=$event">
        <option [ngValue]="null">Select</option>
        @for (item of name902Options; track $index) {
<option [ngValue]="item">{{ item.LEID_902 }}</option>
}
      </select>
    </div>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">Save</button>
  <button class="reset-button" type="button" (click)="reset()">Reset Basket</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
